<template>
  <div id="slider" class="slider container-fluid p-0" data-aos="zoom-in">
    <!-- Slider main container -->
    <div class="swiper-container">
        <div class="swiper-wrapper">
          <div
          v-for="(slide, index) in slider"
          :key="index"
          :style="{ backgroundImage: 'url(' + slide.slide_img.url + ')' }"
          class="swiper-slide">
              <div class="slide-content">
                <div class="container">
                  <div class="row">
                    <div class=" col col-8">
                      <h1 class="title" v-html="slide.slide_title"></h1>
                    </div>
                  </div>
                </div>
              </div>
          </div>
        </div>
        <!-- Add Pagination -->
        <div class="swiper-pagination"></div>
    </div>

  </div>
</template>
<script>
import Swiper from 'swiper'
import api from '@/api'
export default {
  data () {
    return {
      slider: null
    }
  },
  methods: {
    /**
     * Fetch slides data
     * @request HTTP | GET
     */
    fetchSlides () {
      this.axios.get(api.slider)
        .then(response => {
          this.slider = response.data.acf.main_slider
        })
        .catch(error => {
          console.log(error)
        })
    },
    /**
     * Initialize swiper slider
     */
    initSlider () {
      /* eslint-disable */
      var mySwiper = new Swiper('.swiper-container', {
        loop: true,
        autoplay: true,
        effect: 'fade',
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      })
      /* eslint-enable */
    }
  },
  beforeMount () {
    this.fetchSlides()
  },
  mounted () {},
  updated () {
    // Initialize swiper when data changed
    this.initSlider()
  }
}
</script>
<style lang="scss">
  @import '../../../node_modules/swiper/dist/css/swiper.css';
  @import 'Slider';
</style>



// WEBPACK FOOTER //
// src/components/Slider/Slider.vue